import React from "react";
import {
  Col,
  Form,
  Row,
  Switch,
  Typography,
  Tooltip,
  Button,
  Alert,
} from "antd";
import { useQuery } from "react-query";
import { AuthIntegrationApi } from "../Api";
import { InfoCircleOutlined } from "@ant-design/icons";

const SystemPermissionsToggles = ({
  permissions = [],
  permissionsError = false,
}) => {
  const { data: systems, error: systemsError } = useQuery(
    ["systems"],
    () => AuthIntegrationApi.getSystems(),
    { initialValue: [] },
  );

  if (systemsError) {
    return (
      <Alert
        message="Não foi possível carregar informações dos sistemas"
        type="error"
      />
    );
  }

  return (
    <>
      <Row style={{ display: "flex" }}>
        <Typography.Title level={5}>Gerenciar Acessos:</Typography.Title>
      </Row>
      <Row>
        {permissionsError && (
          <Col span={24}>
            <Alert
              message="Não foi possível encontrar permissões de acesso deste usuário."
              type="error"
            />
          </Col>
        )}
        {systems ? (
          systems.map((system) => {
            return (
              <Col
                span={8}
                key={system.key}
                style={{ display: "flex", flexDirection: "row" }}
              >
                <Form.Item
                  valuePropName="checked"
                  name={["systems_permissions", system.key]}
                  initialValue={
                    permissions ? permissions.includes(system.key) : false
                  }
                >
                  <Switch />
                </Form.Item>
                <Typography.Text
                  style={{ paddingLeft: "10px", fontSize: "15px" }}
                >
                  {system.system_info?.name}
                </Typography.Text>
              </Col>
            );
          })
        ) : (
          <></>
        )}
      </Row>
    </>
  );
};

export default SystemPermissionsToggles;
